module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aspin21-d8d01eb373f11b4a020ebea63c122235.jpg";